import Anchor from '@/components/ui/Anchor'
import Container from '@/components/ui/Container'
import Icon from '@/components/ui/Icon'
import { useData } from '@/hooks/useLocale'

/**
 * Three selling points, each led by a big figure; the blue one offers a demo.
 * Side by side from 900px; stacked below, where three would be too narrow.
 */
export default function PathsSection() {
  const { PATHS } = useData()
  return (
    <section className="bg-surface py-18">
      <Container className="grid gap-3.5 md:grid-cols-3">
        {PATHS.map((path) => (
          <div
            key={path.title}
            className={`flex min-h-85 min-w-0 flex-col rounded-3xl p-7 ${path.dark ? 'bg-brand text-white' : 'bg-white'}`}
          >
            <div className="flex items-center gap-3.5">
              <span
                className={`grid size-10 shrink-0 place-items-center rounded-xl ${path.dark ? 'bg-white text-brand' : 'bg-brand text-white'}`}
              >
                <Icon name={path.icon} />
              </span>
              <span className="text-lg font-medium">{path.title}</span>
            </div>

            <span className="mt-auto text-[clamp(48px,5vw,68px)] leading-[1.05] font-normal tracking-[-0.04em]">
              {path.stat}
            </span>
            <p
              className={`mt-2.5 mb-6 max-w-110 text-base/[1.6] text-pretty ${path.dark ? 'text-[#e3edfd]' : 'text-muted'}`}
            >
              {path.text}
            </p>
            <Anchor
              href={path.link.href}
              className={`flex items-center gap-2 self-start text-[15px] font-semibold ${path.dark ? 'text-white hover:text-[#d2e3fc]' : 'text-ink hover:text-brand'}`}
            >
              {path.link.label}
              <Icon name="arrowUpRight" size={13} stroke={2.2} />
            </Anchor>
          </div>
        ))}
      </Container>
    </section>
  )
}
